import { Box } from "@mui/material";
import SleepChart, { SleepChartDataPoint } from "./index";

const sampleData: SleepChartDataPoint[] = [
  { date: "20/01", sleepHours: 6.5, fullDate: "20.01.2025" },
  { date: "02/04", sleepHours: 7.5, fullDate: "02.04.2025" },
  { date: "04/04", sleepHours: 8, fullDate: "04.04.2025" },
  { date: "12/05", sleepHours: 6, fullDate: "12.05.2025" },
  {
    date: "20/08",
    sleepHours: 9.5,
    fullDate: "20.08.2025",
    isSelected: true,
  },
];

export default function SleepChartExamples() {
  return (
    <Box sx={{ padding: 2 }}>
      <SleepChart data={sampleData} />
    </Box>
  );
}
